import {
  formatDistanceToNow,
  differenceInHours,
  format as formatDateFn,
  isToday,
  isYesterday,
} from "date-fns";
import { TZDate } from "@date-fns/tz";
import _padStart from "lodash/padStart";
import { Booking } from "./api";

export function formatDate(date: Date, timeZone?: string) {
  let value = date;

  if (timeZone) {
    value = new TZDate(date, timeZone);
  }

  return formatDateFn(value, "E d MMM");
}

export function formatTime(date: Date, timeZone?: string) {
  let value = date;

  if (timeZone) {
    value = new TZDate(date, timeZone);
  }

  return formatDateFn(value, "hh:mm aaa");
}

export function formatDuration(minutes: number) {
  const hh = Math.floor(minutes / 60);
  const mm = minutes % 60;
  const human = [];

  if (hh !== 0) {
    human.push(`${hh}h`);
  }

  if (mm !== 0) {
    human.push(`${mm}${hh === 0 ? " min" : ""}`);
  }

  if (human.length) {
    return human.join(" ");
  }

  return `${minutes} min`;
}

export function formatTimer(seconds: number) {
  const min = `${Math.floor(seconds / 60)}`;
  const sec = `${seconds % 60}`;

  return `${_padStart(min, 2, "0")}:${_padStart(sec, 2, "0")}`;
}

export function formatDaysLeft(date: Date) {
  const hours = differenceInHours(date, new Date());

  if (hours <= 0) {
    return "EXPIRED";
  }

  if (hours < 24) {
    return "< 1 DAY LEFT";
  }

  if (hours === 24) {
    return "1 DAY LEFT";
  }

  return `${Math.ceil(hours / 24)} DAYS LEFT`;
}

export function wordsToNow(date: Date) {
  return formatDistanceToNow(date);
}

export function formatMonth(date: Date) {
  return formatDateFn(date, "MMM yyyy");
}

export function formatDay(date: Date) {
  if (isToday(date)) {
    return "Today";
  }

  if (isYesterday(date)) {
    return "Yesterday";
  }

  // Sun 1 Jan
  return formatDateFn(date, "E d MMM");
}

export function getBookingStatus(booking: Booking) {
  if (booking.cancelled) {
    return "CANCELLED";
  }

  if (booking.completed) {
    return "COMPLETED";
  }

  if (booking.accepted) {
    return "IN PROGRESS";
  }

  return "PENDING";
}
